/* Megamenu */
$('.navigation-chevron').click(function (event) {
  var self = $(this).parent();
  $('.navigation-item').not(self).removeClass('open');
  self.toggleClass("open");
});

$('.header-action-toggle').click(function () {
    $('.fade-overlay').addClass('open');
});

/* Collpase other navigation dropdowns when next ones clicked */
$('.navigation-chevron ').click( function(e) {
    $('.navigation-submenu').collapse('hide');
});

$(document).mouseup(function(e)
{
    var container = $(".navigation-wrapper");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0)
    {
        $('.navigation-megamenu-panel').collapse('hide');
        $('.navigation-submenu').collapse('hide');
        $('.navigation-item').removeClass('open');

        $('.navigation-wrapper').collapse('hide');

    }
}).on('hidden.bs.collapse', function(e) {
    $('.fade-overlay').removeClass('open');
});

/* Disable search till input */
let searchFields = ['#SearchForm_SearchForm_Search', '#mobileSearchForm_SearchForm_Search', '#BlogSearchForm_SearchForm'],
    buttons = document.querySelectorAll(".search-submit").forEach(function(el) {
        el.disabled = true;
    }),
    stateHandle = function (event) {
        let input = event.target,
            button = input.nextElementSibling;

        if(input.value.length == 0) {
            button.disabled = true;
        } else {
            button.disabled = false;
        }
    };

searchFields.forEach(function (selector) {

    let inputField = document.querySelector(selector);
    if(inputField) {
        inputField.addEventListener("keyup", stateHandle);
    }
});
